// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// eslint-disable-next-line
import Vue from 'vue';
import moment from 'moment';
import App from './App';
import router from './router';
import axios from 'axios';
import { ACCESS_TYPE, API_BASE_URL } from '@/constants';
// 引入lke统一渲染插件
import lkeComponent from 'lke-component';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(lkeComponent);
const vhtml = window.vhtml;
Vue.use(vhtml);
vhtml.install(Vue);

try {
  let iconpath = 'https://cdn3.codesign.qq.com/icons/XzKaDZdEa7j2GPL/latest/iconfont.js';
  vhtml.Icon.setDefaultRemoteSrc && vhtml.Icon.setDefaultRemoteSrc(iconpath);
} catch (e) {
  console.log('load remote icon error');
}

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

// 路由守衛已移至 src/router/index.js 中統一管理
// 避免多個路由守衛導致衝突

let webIMType; // 后端ws识别的端类型
let webIMSource; // 前端区分UI交互的端类型

webIMType = [5];
window.$initTypeKey = 5;
webIMSource = 'client';

Vue.prototype.webIMSource = webIMSource;

Object.defineProperty(window, 'userType', {
  writable: false,
  enumerable: false,
  configurable: false,
  value: 2
});

window.$initType = 'ComplianceAssistant';

// 導入 EventHub（總是需要的）
import '@/manage/utils/EventHub';

// 初始化應用
(async () => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    render (h) {
      return h(App);
    }
  }).$mount('#app');
})();



// WEBPACK FOOTER //
// ./src/main.js